import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const doSalesSlice = createAsyncThunk(
  "sales/doSales",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/sales/doSales", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const receiptDueAmountSlice = createAsyncThunk(
  "sales/receiptDueAmount",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/sales/receiptDueAmount", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getSalesSlice = createAsyncThunk(
  "sales/getSales",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post("/sales/getSales", serchingFor, {
        headers: {
          "Content-Type": "application/json",
          token: serchingFor.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const getSalesByIdSlice = createAsyncThunk(
  "sales/getSalesById",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post("/sales/getSalesById", serchingFor, {
        headers: {
          "Content-Type": "application/json",
          token: serchingFor.token,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const getMyCollection = createAsyncThunk(
  "sales/getSalesCollection",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/sales/getSalesCollection",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  sales: [],
  salesById: [],
  myCollection: [],
  isLoading: false,
  createSalesSuccessMessage: null,
  createSalesErrorMessage: null,
  reciveAmountSuccessMessage: null,
  reciveAmountErrorMessage: null,
  searchMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const salesSlice = createSlice({
  name: "sales",
  initialState,
  reducers: {
    resetMessage: (state) => {
      state.createSalesSuccessMessage = null;
      state.createSalesErrorMessage = null;
    },
    resetReciveAmountMessage: (state) => {
      state.reciveAmountSuccessMessage = null;
      state.reciveAmountErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doSalesSlice.pending, (state) => {
        state.isLoading = true;
        state.createSalesSuccessMessage = null;
        state.createSalesErrorMessage = null;
      })
      .addCase(doSalesSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.createSalesErrorMessage = action.payload.result.message;
        } else {
          state.createSalesSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(doSalesSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(receiptDueAmountSlice.pending, (state) => {
        state.isLoading = true;
        state.reciveAmountSuccessMessage = null;
        state.reciveAmountErrorMessage = null;
      })
      .addCase(receiptDueAmountSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.reciveAmountErrorMessage = action.payload.result.message;
        } else {
          state.reciveAmountSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(receiptDueAmountSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getSalesSlice.pending, (state) => {
        state.isLoading = true;
      })

      .addCase(getSalesSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.success) {
          state.sales = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchMessage =
            action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.sales = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })

      .addCase(getSalesSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.searchMessage = action.payload.result?.message;
      })
      .addCase(getSalesByIdSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSalesByIdSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
        }
        state.salesById = action.payload.result.list;
      })
      .addCase(getSalesByIdSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getMyCollection.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMyCollection.fulfilled, (state, action) => {
        state.isLoading = false;
        state.myCollection = action.payload.result.list;
      })
      .addCase(getMyCollection.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});
export const { resetMessage, resetReciveAmountMessage } = salesSlice.actions;

export default salesSlice.reducer;
